// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"6d6dbdd4","453":"18a52e2a","865":"6c67f071"}[chunkId] + ".chunk.js";
};